var _defs, _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSuccessRocket = function SvgSuccessRocket(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 140",
    width: "100%",
    height: "100%",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edf0f2;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#fff;}.cls-4{fill:#fbd048;}.cls-5{fill:#fbd149;}.cls-6{fill:#6d8491;}.cls-7{fill:#53717f;}.cls-8{fill:#cfd5d8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 70.77,
    y1: 131.57,
    x2: 70.77,
    y2: 87.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f5f6f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  })))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Success")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.77,
    cy: 71.56,
    r: 60
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clouds",
    className: "cls-2",
    d: "M70.77,109.59A5.82,5.82,0,0,1,70.93,98a5.74,5.74,0,0,1,2.8.72.55.55,0,0,0,.14-.12c2.94-4.14,6.41-4.9,9.76-1.85,1.84-5.79,5-8.7,9.66-8.9,5-.22,10,1.63,10.74,7.63,4-.21,7.12,1.07,9.17,4.61a2.09,2.09,0,0,0,1.44.64,4.93,4.93,0,0,1,4.15,2.64,3.57,3.57,0,0,1,.42,2,4.17,4.17,0,0,1-.73,2.66A60.9,60.9,0,0,1,101,123.46,60,60,0,0,1,23.13,108a4.21,4.21,0,0,1-.79-2.67,3.57,3.57,0,0,1,.42-2,4.91,4.91,0,0,1,4.14-2.64,2.11,2.11,0,0,0,1.45-.64c2-3.54,5.19-4.82,9.17-4.61.75-6,5.78-7.85,10.73-7.63,4.67.2,7.82,3.11,9.67,8.9,3.34-3,6.81-2.29,9.75,1.85a.81.81,0,0,0,.14.12,5.82,5.82,0,1,1,2.8,10.92h-.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.65,107.33A5.9,5.9,0,0,0,80,105.19c-1.21-.45-2.69.14-3.36-1a6.65,6.65,0,0,0-7.34-2.8A5.71,5.71,0,0,0,66,103.74c-.3.4-.65,1.48-1,1.73.39-.26-1.41-.15-1.62-.12A5.19,5.19,0,0,0,58.8,111c.07.82,1.36.83,1.29,0-.3-3.23,2.57-4.58,5.37-4.34a.64.64,0,0,0,.56-.32,6,6,0,0,1,3.34-3.62,5.76,5.76,0,0,1,5.37,1.14c.8.77,1,2.14,2.24,2.38,1,.21,1.83-.17,2.92.36A4.6,4.6,0,0,1,81.54,108c.48.67,1.6,0,1.11-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,108a4.53,4.53,0,0,1,1.65-1.42c1-.52,1.9-.16,2.92-.36,1.25-.24,1.42-1.61,2.24-2.38a5.78,5.78,0,0,1,5.37-1.14c1.64.49,2.7,2.12,3.34,3.62a.62.62,0,0,0,.55.32c2.81-.24,5.68,1.12,5.38,4.34-.08.83,1.21.82,1.29,0a5.19,5.19,0,0,0-4.48-5.6c-.32,0-.64-.07-1-.08,0,0-1.22-.12-.74.19-.4-.25-.7-1.3-1-1.73a5.74,5.74,0,0,0-3.26-2.36c-2.62-.64-5.81.22-7.24,2.62-.32.53-.3.77-1,.89a12.65,12.65,0,0,0-2.51.3,5.84,5.84,0,0,0-2.69,2.14c-.48.67.64,1.32,1.12.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trail"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.14,90q0,12.27-.07,24.54a.65.65,0,0,0,1.29,0q0-12.27.07-24.54a.65.65,0,0,0-1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.62,92.8q0,9.89-.07,19.76a.65.65,0,0,0,1.29,0q0-9.89.07-19.76a.65.65,0,0,0-1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.64,92.8q0,9.89.07,19.76a.65.65,0,0,0,1.29,0q0-9.89-.07-19.76a.65.65,0,0,0-1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.74,118a.65.65,0,0,1-1.1-.46v-1.62a.65.65,0,1,1,1.29,0v1.61A.64.64,0,0,1,66.74,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.16,119.41a.69.69,0,0,1-.46.19.65.65,0,0,1-.64-.65v-1.62a.65.65,0,1,1,1.29,0V119A.64.64,0,0,1,71.16,119.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.68,118a.65.65,0,0,1-1.1-.46v-1.62a.65.65,0,1,1,1.29,0v1.61A.64.64,0,0,1,75.68,118Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rocket"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.8,8.43C86.43,24,93.66,42,87.71,64c3,1.84,6,3.64,9,5.5a1.63,1.63,0,0,1,.77,1.09c0,2.49,0,5-.08,7.71h-19a10.2,10.2,0,0,1,2.53,6.47l-20.23,0a9.56,9.56,0,0,1,2.45-6.44L44,78.32c0-2.82,0-5.37,0-7.92,0-.27.37-.61.64-.78,3-1.86,6.08-3.71,9.19-5.6C47.83,42,55.05,24,70.8,8.43Zm4.84,20a6.93,6.93,0,0,0-9.84,9.76,6.93,6.93,0,1,0,9.84-9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.8,8.43C86.43,24,93.65,42,87.71,64c3,1.84,6,3.64,9,5.5a1.64,1.64,0,0,1,.78,1.09c0,2.49,0,5-.08,7.71h-19a10.2,10.2,0,0,1,2.53,6.46H70.77"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 70.74,
    cy: 33.38,
    r: 6.95
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-rocket.de81012b.svg";
export { ForwardRef as ReactComponent };